/* eslint-disable import/no-anonymous-default-export */
export default {
    colors: {
        background: 'radial-gradient(#282c34cc, #282c34)',
        black: '#282c34',
        orange: '#ffb627',
        lightOrange: '#ffc971',
        white: 'white',
    },
    transition: '0.3s',
}
